import React, { useState } from "react";
import { useStyle } from "./LoanAcceptance.styles";
import { formatPercentageFromRatio } from "../../Utils/formatter";

interface TableRow {
  skuId: string;
  description: string;
  loanAmount2: string;
  loanAmount2OtherCurrency: string;
  otherCurrency: string;
  loanToValueSku: string;
  interestRate: string;
  tenure: number;
  adminFee: string;
  acquirerFees: string;
  loanApplicationCurrency: string;
}

interface MyTableProps {
  data: TableRow[];
  onCheckboxChange: (skuId: string) => void;
}

const MyTable: React.FC<MyTableProps> = ({ data, onCheckboxChange }) => {
  const { classes } = useStyle();
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedRowIndices, setSelectedRowIndices] = useState<number[]>([]);

  const handleCheckboxChange = (rowId: number) => {
    const id = data[rowId].skuId;

    onCheckboxChange(id);

    const updatedSelectedRowIndices = [...selectedRowIndices];
    if (updatedSelectedRowIndices.includes(rowId)) {
      // If rowId is already selected, remove it
      updatedSelectedRowIndices.splice(
        updatedSelectedRowIndices.indexOf(rowId),
        1
      );
      setSelectAllChecked(false);
    } else {
      // If rowId is not selected, add it
      updatedSelectedRowIndices.push(rowId);

      if (data.length === updatedSelectedRowIndices.length) {
        setSelectAllChecked(true);
      }
    }
    setSelectedRowIndices(updatedSelectedRowIndices);
  };

  const handleAllCheckboxSelected = () => {
    const newSelectAllChecked = !selectAllChecked;
    setSelectAllChecked(newSelectAllChecked);

    if (newSelectAllChecked) {
      // If "Select All" is checked, select all rows
      setSelectedRowIndices(data.map((_, index) => index));
    } else {
      // If "Select All" is unchecked, deselect all rows
      setSelectedRowIndices([]);
    }

    data.forEach((row, index) => {
      // You might need to adjust this part depending on how you're handling selected rows
      onCheckboxChange(row.skuId);
    });
  };

  return (
    <table
      style={{ borderCollapse: "collapse", width: "100%", border: "none" }}
    >
      <thead>
        <tr>
          <th className={classes.thh}>
            <input
              type="checkbox"
              checked={selectAllChecked}
              onChange={handleAllCheckboxSelected}
            />
          </th>
          <th className={classes.thh}>SKU ID</th>
          <th className={classes.thh}>Description</th>
          <th className={classes.thh}>Indicative Tenure</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td className={classes.th} style={{ border: "none" }}>
              <input
                type="checkbox"
                checked={selectedRowIndices.includes(index)}
                onChange={() => handleCheckboxChange(index)}
              />
            </td>
            <td className={classes.th}>{row.skuId}</td>
            <td className={classes.th}>{row.description}</td>
            <td className={classes.th}>{row.tenure + " days"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MyTable;
